import { Fragment, type ReactNode, useMemo } from 'react'
import { Link } from '@router'
import type { Activity } from '@hewey/shared'
import { buildCollections } from './collections.ts'
import { CollectionRow } from './CollectionRow.tsx'
import type { ActivityFilter } from './filter.ts'
import type { TodayWeather } from './weather.ts'
import styles from './ExploreCollections.module.css'

type Props = {
	activities: Activity[]
	origin: { lat: number; lng: number } | null
	weather: TodayWeather | null
	placeName: string | null
	locationSlot: ReactNode
	onSeeAll: (patch: Partial<ActivityFilter>) => void
}

// Explore's "zen" state: the suggested-collection rows, shown when there's no
// search query and no active filter. The Nearby and weather rows need the
// user's location; the parent fills `locationSlot` with the one-tap prompt or
// the lookup's status, shown under the first row.
export const ExploreCollections = ({
	activities,
	origin,
	weather,
	placeName,
	locationSlot,
	onSeeAll,
}: Props) => {
	const collections = useMemo(
		() => buildCollections({ activities, origin, weather, placeName }),
		[activities, origin, weather, placeName],
	)

	return (
		<div className={styles.rows}>
			{collections.map((c, i) => {
				const patch = c.seeAll
				return (
					<Fragment key={c.key}>
						<CollectionRow
							title={c.title}
							subtitle={c.subtitle}
							activities={c.activities}
							onSeeAll={patch ? () => onSeeAll(patch) : undefined}
						/>
						{i === 0 ? locationSlot : null}
					</Fragment>
				)
			})}

			<Link href="/activities/all" className={styles.viewAll}>
				View all activities
			</Link>
		</div>
	)
}
